import InputComponent from "V2.0/components/InputComponent";
import { Button } from "V2.0/common/button";
import { Switch } from "V2.0/common/switch";
import { ExclamationCircleIcon } from "@heroicons/react/24/outline";

function DisabledInfo() {
  return (
    <div className="flex gap-x-2 items-center w-full text-wrap">
      <ExclamationCircleIcon className="text-blue-500 size-4" />
      <p className="font-xs text-xs text-blue-500">
        If turned OFF, the assistant will wait for the User to speak first
      </p>
    </div>
  );
}

export default function InboundWelcomeMessageSettings(props) {
  const { welcomeMessageSettings, onUpdate, onSave, locked } = props;

  function handleToggleInitiateInbound() {
    onUpdate({
      shouldAgentSpeakFirstInbound:
        !welcomeMessageSettings.shouldAgentSpeakFirstInbound,
    });
  }

  function handleUpdateInboundMessage(inboundWelcomeMessages) {
    onUpdate({
      inboundWelcomeMessages,
    });
  }

  return (
    <div className="grid grid-cols-3 space-y-4">
      <div className="flex flex-col gap-y-2 col-span-3">
        <div className=" flex gap-x-4 items-center">
          <p className="text-sm font-semibold">Assistant Initiates Conversation</p>
          <Switch
            color="emerald"
            checked={welcomeMessageSettings.shouldAgentSpeakFirstInbound}
            onClick={handleToggleInitiateInbound}
            disabled={locked}
          />
        </div>
        <DisabledInfo />
      </div>
      <div className="col-span-3 ml-4">
        <InputComponent
          type="textArea"
          label="Message"
          value={welcomeMessageSettings.inboundWelcomeMessages}
          disabled={
            locked || !welcomeMessageSettings.shouldAgentSpeakFirstInbound
          }
          style={{ height: "100px", fontSize: "13px" }}
          onChange={(e) => handleUpdateInboundMessage(e.target.value)}
        />
      </div>
    </div>
  );
}
